import Locales from 'bundles/common/constants/Locales';

function getAvailableLocalesForUser() {
  return Object.keys(Locales).map((languageKey) => ({
    // Transforming the standard format is <lang>-<countryCode> to be acceptable by Maestro
    key: languageKey.replace('-', '_'),
    label: Locales[languageKey as keyof typeof Locales],
  }));
}

export { getAvailableLocalesForUser };
